import React, { useRef } from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { UnlinkIcon } from '../../ui/icons/unlink-icon'

interface LinkToolbarProps {
  url: string | undefined
  update: (value: string) => void
  toggleShowFileManager: () => void
  remove: () => void
}

export const LinkSourceInput = ({
  update,
  url,
  toggleShowFileManager,
  remove,
}: LinkToolbarProps) => {
  const { t } = useTypedTranslation()
  const inputRef = useRef<HTMLInputElement>(null)
  const handleURLChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    update(event.target.value)
  }
  return (
    <div className="flex items-center justify-between px-6 py-3">
      <label htmlFor="link-input" className="block text-heading-5">
        {t('components.core.text_editor.link_toolbar.link')}
      </label>
      <div className="flex h-[37px] w-2/3 rounded-lg border border-gray-200">
        <input
          ref={inputRef}
          placeholder={t('components.core.text_editor.link_menu.placeholder')}
          type="text"
          style={{ width: 'inherit' }}
          className="flex w-full flex-auto py-2.5 pl-3 text-M focus:outline-none"
          value={url}
          onChange={handleURLChange}
        />
        {url && (
          <button
            type="button"
            className="cursor-pointer px-3 hover:bg-gray-100"
            onClick={remove}
            title={t('components.core.text_editor.link_menu.unlink')}
          >
            <UnlinkIcon />
          </button>
        )}
        <div className="max-h-52 w-px bg-divider03" />
        <button
          type="button"
          className="flex w-[38px] cursor-pointer items-center justify-center hover:bg-gray-100"
          title={t('components.core.text_editor.link_menu.use_file_as_link')}
          onClick={() => {
            inputRef.current?.focus()
            toggleShowFileManager()
          }}
        >
          <i className="fa-light fa-arrow-up-from-bracket text-M" />
        </button>
      </div>
    </div>
  )
}
